<template>
    <div>
      <!-- Button to trigger dialog -->
      <v-btn color="primary" small rounded @click="openDialog">
        ดูรายละเอียด
      </v-btn>

      <v-dialog v-model="dialog" max-width="800px" height="1000px">
        <v-card>
          <v-card-title>
            <v-btn
              icon
              @click="closeDialog"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <h4 class="mx-4 mt-2">รายชื่อลูกค้านัดหมาย</h4>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="closeDialog"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div>{{ flowName }}</div>
            <div><v-icon>mdi-account-outline</v-icon>&nbsp;&nbsp;{{ this.$session.getAll().data.shopId == 'U5f25883688c37a34f4dace2645272407' ? 'ล่าม' : $session.getAll().data.shopId == shopNameData.velaEntertainment ? 'Studio' : 'พนักงาน' }}&nbsp;{{ bookingEmpFlowName }}</div>
            <div><v-icon>mdi-map-marker-outline</v-icon>&nbsp;&nbsp;สาขา&nbsp;{{ masBranchName }}</div>
            <div><v-icon>mdi-calendar-outline</v-icon>&nbsp;&nbsp;{{ date }} </div>
            <div><v-icon>mdi-clock-outline</v-icon>&nbsp;&nbsp;{{ time }}</div>
            <hr>
            <div v-for="(field, index) in dataCustomField" :key="index">
              <div class="style-dialog">
                <span class="field-name">{{ field.fieldName }}</span>
                <span class="field-value">{{ field.fieldValue }}</span>
              </div>
            </div>
            <div v-if="bookingData && bookingData[0] && (bookingData[0].joyRideInsurance === 'True' || bookingData[0].joyRideReserveNow === 'True' || bookingData[0].menuItem !== null)" class="ms-2 pa-2" style="font-weight: bold;">
              <hr>
              <span v-if="bookingData[0].joyRideInsurance === 'True'"> จองด่วน 12 ชั่วโมง + 300 บาท </span><br>
              <span v-if="bookingData[0].joyRideReserveNow === 'True'"> ซื้อประกันอุบัติเหตุเพิ่ม TQM 35 บาท</span><br>
              <!-- <div class="booking-info">
                <span class="price">{{ bookingName[0].price }} บาท</span>
                <span class="name">{{ bookingName[0].name }}</span>
              </div> -->
            </div>
            <div class="field-container">
              <span class="field-name">หมายเหตุ</span>
              <!-- <span class="field-value">{{ dataItem }}</span> -->
            </div>
            <div class="field-container">
              <v-textarea color="black" v-model="dataItem" readonly>
              </v-textarea
              >
            </div>
          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>

<script>
import axios from 'axios'
export default {
  props: ['bookNo', 'flowName', 'masBranchName', 'date', 'time', 'bookingEmpFlowName', 'dataItem'],
  watch: {
    bookNo (newVal) {
      this.fetchData()
    }
  },
  data () {
    return {
      dialog: false, // Controls the visibility of the dialog
      dataCustomField: [],
      bookingData: [],
      bookingName: []
    }
  },
  async mounted () {
    await this.fetchData()
    await this.getBooking()
  },
  methods: {
    async fetchData () {
      let url = `${this.$DNS_IP}/BookingData/getView?bookNo=${this.bookNo}`

      try {
        const response = await axios.get(url)
        console.log('data all ', response.data)

        for (let index = 0; index < response.data.length; index++) {
          if (response.data[index].fieldType === 'Checkbox') {
            console.log('data index ', typeof response.data[index].fieldValue)

            // Check if fieldValue is falsy (null, undefined, empty string, etc.)
            if (response.data[index].fieldValue && response.data[index].fieldValue !== '') {
              // Convert the fieldValue to an actual array if it's a string
              if (typeof response.data[index].fieldValue === 'string') {
                try {
                  // If the string is a valid array in string format, parse it into an array
                  // eslint-disable-next-line no-useless-escape
                  let parsedValue = JSON.parse(response.data[index].fieldValue.replaceAll("'", "\'"))

                  // Remove the surrounding [] by assigning the parsed array directly
                  response.data[index].fieldValue = parsedValue.join(', ') // Joins the array elements as a string
                } catch (e) {
                  console.error('Error parsing fieldValue:', e)
                }
              }
            } else {
              // If there's no data in fieldValue (either falsy or empty), set it to '-'
              response.data[index].fieldValue = '-'
            }

            console.log('Converted fieldValue: ', response.data[index].fieldValue)
          }
        }

        // Check if response.data is an array and has items
        if (Array.isArray(response.data) && response.data.length > 0) {
          this.dataCustomField = response.data // Set data if successfully fetched
          console.log('Data fetched successfully:', this.dataCustomField)
        } else {
          console.log('No data found or response is not an array.')
          this.dataCustomField = [] // Set to an empty array if no data is found
        }
      } catch (error) {
        console.error('Error fetching data:', error) // Use error for better clarity
        this.dataCustomField = [] // Set to an empty array if there's an error
      }
    },
    openDialog () {
      // Open the dialog when the button is clicked
      this.dialog = true
    },
    closeDialog () {
      // Close the dialog
      this.dialog = false
    },
    async getBooking () {
      console.log('bookNo ', this.bookNo)
      let url = `${this.$DNS_IP}/Booking/get?bookNo=${this.bookNo}`

      try {
        const response = await axios.get(url)

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.bookingData = response.data
          console.log('Data fetched successfully:', this.bookingData)
          this.bookingName = JSON.parse(response.data[0].menuItem)
          console.log('this.bookingName ', typeof this.bookingName)
        } else {
          console.log('No data found or response is not an array.')
          this.bookingData = []
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.bookingData = []
      }
    }
  }
}
</script>

<style scoped>
  .style-dialog {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      width: auto; /* ให้ปรับขนาดตามข้อมูล */
      max-width: 100%; /* ป้องกันไม่ให้ขยายเกินขนาดหน้าจอ */
      min-width: 200px; /* กำหนดขนาดขั้นต่ำ หากต้องการ */
  }

  .field-name {
      flex: 1;
      text-align: left;
  }

  .field-value {
      flex: 1;
      text-align: left;
      color: #000;
      font-weight: bold;
      padding-inline-start: 60px;
      align-self: flex-start;
  }
  .sytle-text-align {
    padding-right: 40px;
  }
  .booking-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-direction: row-reverse; /* สลับตำแหน่งซ้าย-ขวา */
}

.price {
  text-align: left; /* ชิดซ้าย */
}

.name {
  text-align: right; /* ชิดขวา */
}
</style>



// WEBPACK FOOTER //
// src/components/DialogModels/DialogcustomField.vue